import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Container, Form, InputOnChangeData, Message } from "semantic-ui-react";

import { Credentials } from "../auth/types";
import { Routes } from "../constants";

interface LoginProps {
  logIn: (credentials: Credentials) => Promise<boolean>;
}

export default function Login({ logIn }: LoginProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  // These credentials refer to the ones provided by the user in the login screen
  const [credentialsFailed, setCredentialsFailed] = useState(false);
  const [loading, setLoading] = useState(false);

  const browserPageHistory = useHistory();

  function handleSubmit() {
    setLoading(true);

    logIn({ username, password }).then((success: boolean) => {
      if (success) {
        const nextPage = Routes.PRODUCTS;
        console.debug(`Redirecting user to "${nextPage}" ...`);
        browserPageHistory.push(nextPage);
      } else {
        setLoading(false);
        setUsername("");
        setPassword("");
        setCredentialsFailed(true);
      }
    });
  }

  function handleChange(_: any, { name, value }: InputOnChangeData): void {
    switch (name) {
      case "username":
        setUsername(value);
        break;
      case "password":
        setPassword(value);
        break;
      default:
        break;
    }
  }

  return (
    <Container style={{ width: 450, marginTop: "30vh" }}>
      <h1 id="greeting">¡Hola!</h1>
      <Form loading={loading} onSubmit={handleSubmit}>
        <Form.Field>
          <Form.Input
            placeholder="Usuario"
            name="username"
            value={username}
            onChange={handleChange}
          />
        </Form.Field>
        <Form.Field>
          <Form.Input
            placeholder="Contraseña"
            type="password"
            name="password"
            value={password}
            onChange={handleChange}
          />
        </Form.Field>
        <Button type="submit">Iniciar sesión</Button>
      </Form>
      {credentialsFailed ? (
        <Message
          error
          header="Credenciales inválidos"
          content="El usuario y/o contraseña proporcionados no son validos."
        />
      ) : null}
    </Container>
  );
}
